import { v4 as uuidv4 } from 'uuid';
import { CampaignConfig, CampaignDetails } from 'schemas/CampaignConfig.schema.ts';

// eslint-disable-next-line import/prefer-default-export
export function updateCampaignDetails(existingCampaign: CampaignConfig, newCampaignDetails: CampaignDetails): CampaignConfig {
  return {
    ...existingCampaign,
    CampaignConfig: {
      ...existingCampaign.CampaignConfig,
      ...newCampaignDetails,
      Version: existingCampaign.CampaignConfig.Version
        ? existingCampaign.CampaignConfig.Version
        : 0,
      ID: existingCampaign.CampaignConfig.ID
        ? existingCampaign.CampaignConfig.ID
        : uuidv4(),
      IterationFrequency: existingCampaign.CampaignConfig.IterationFrequency
        ? existingCampaign.CampaignConfig.IterationFrequency
        : 'X',
      IterationType: existingCampaign.CampaignConfig.IterationType
        ? existingCampaign.CampaignConfig.IterationType
        : 'M',
      IterationTime: existingCampaign.CampaignConfig.IterationTime
        ? existingCampaign.CampaignConfig.IterationTime
        : '07:00:00',
      DefaultCommsRouting: existingCampaign.CampaignConfig
        .DefaultCommsRouting
        ? existingCampaign.CampaignConfig.DefaultCommsRouting
        : 'PLACEHOLDER_COMMS_ROUTING',
      ApprovalMinimum: existingCampaign.CampaignConfig.ApprovalMinimum
        ? existingCampaign.CampaignConfig.ApprovalMinimum
        : 0,
      ApprovalMaximum: existingCampaign.CampaignConfig.ApprovalMaximum
        ? existingCampaign.CampaignConfig.ApprovalMaximum
        : 0,
    },
  };
}
